import { BasementWallInput } from '@core/const'
import { BasementWallResponse } from '@core/query'
import { Dispatch, PropsWithChildren, SetStateAction, createContext, useContext, useMemo, useState } from 'react'
import { UseFormReturn, useForm } from 'react-hook-form'

const defaultFormValues: BasementWallInput = {
  b1Height: 0,
  b2Height: 0,
  b3Height: 0,
  b4Height: 0,
  b5Height: 0,
  whetherCalc: [1, 1, 1, 1, 1],
}

interface BasementWallContext {
  form: UseFormReturn<BasementWallInput>
  result: BasementWallResponse | null
  setResult: Dispatch<SetStateAction<BasementWallResponse | null>>
}

const context = createContext<BasementWallContext | undefined>(undefined)

const useDefaultContextValues = () => {
  const form = useForm<BasementWallInput>({
    defaultValues: defaultFormValues,
  })

  const [result, setResult] = useState<BasementWallResponse | null>(null)

  return useMemo(() => ({
    form,
    result,
    setResult,
  }), [form, result])
}

export function BasementWallProvider ({ children }: PropsWithChildren) {
  const { Provider } = context
  const defaultContextValues = useDefaultContextValues()

  return (
    <Provider value={defaultContextValues}>
      {children}
    </Provider>
  )
}

export const useBasementWall = () => {
  const contextValues = useContext(context)
  const defaultContextValues = useDefaultContextValues()

  return contextValues ?? defaultContextValues
}
